import * as React from 'react'
import { Whisper, Tooltip, IconButton, Icon } from 'rsuite'

export default function WhisperMoreContent({ onClick, isShow, ...props }) {
  return (
    <Whisper
      trigger="hover"
      speaker={
        isShow ? (
          <Tooltip>
            <small>ย่อเนื้อหา</small>
          </Tooltip>
        ) : (
          <Tooltip>
            <small>ดูเพิ่มเติม</small>
          </Tooltip>
        )
      }
    >
      <IconButton
        icon={<Icon icon={isShow ? 'up' : 'down'} />}
        appearance="link"
        onClick={onClick}
      />
    </Whisper>
  )
}
